<template>
  <div class="product-review-summary-container">
    <div class="product-review-summary">
      <div class="product-review-summary-heading" :class="{ 'product-review-summary-single-row': !review.rating }">
        <h2 class="light"><template v-if="reviewCount">{{ reviewCount }} </template>Review{{ reviewCount === 1 ? '' : 's' }}</h2>
        <div class="product-review-summary-details">
          <Rating v-if="review.rating" :max="5" :value="review.rating" :show-half-star="true"></Rating>
          <div v-if="ratingFormatted" class="product-review-rating-average">
            <span class="product-review-average-text">Avg. </span>{{ ratingFormatted }} stars
          </div>
          <a class="show-review-policy" title="Our review policy" @click.passive="togglePolicy()"><i class="af af-about-small"></i></a>
        </div>
      </div>
      <div>
        <div class="product-review-actions">
          <div class="product-review-loader"><div v-if="loading && !error" class="loader tiny" /></div>
          <div class="product-review-action">
            <a class="small secondary button product-review-login" :href="reviewUrl">
              <template v-if="isLoggedIn">Write a review</template>
              <template v-else>Log in to review</template>
            </a>
          </div>
          <div v-if="reviewCount >= 5" class="product-review-action product-review-filter">
            <SingleSelect :value="filterStar" @input="$emit('updateStars', $event)" class="star-filters" title="Filter by:" :options="starFilterOptions"></SingleSelect>
          </div>
        </div>
        <ReviewTags
          v-if="reviewCount >= 5 && availableTagNames && availableTagNames.length"
          :value="filterTag"
          @input="$emit('updateTags', $event)"
          class="review-tags-container"
          :tags="availableTagNames"
        ></ReviewTags>
      </div>
    </div>
    <div v-if="isPolicyShown" class="product-review-policy-container">
      <ProductReviewPolicy></ProductReviewPolicy>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import { Select as SingleSelect } from '@article/pixel';
import UserService from '@/services/UserService';
import Rating from './Rating.vue';
import ProductReviewPolicy from './ProductReviewPolicy.vue';
import ReviewTags from './ReviewTags.vue';

export default {
  components: {
    SingleSelect,
    Rating,
    ProductReviewPolicy,
    ReviewTags,
  },

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    filterStar: {
      type: String,
      default: 'ALL'
    },
    filterTag: {
      type: String,
      default: ''
    },
    availableTags: {
      type: Array,
      default: () => []
    },
    reviewCount: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      isPolicyShown: false,
      starFilterOptions: [
        { id: '', description: 'All reviews' },
        { id: '5', description: '5 star reviews' },
        { id: '4', description: '4 star reviews' },
        { id: '3', description: '3 star reviews' },
        { id: '2', description: '2 star reviews' },
        { id: '1', description: '1 star reviews' }
      ]
    };
  },

  computed: {
    ...mapState('product', ['product']),
    ...mapState('common', ['user']),
    ...mapGetters('product', ['reviewUrl']),

    review() {
      return this.product && this.product.review ? this.product.review : {};
    },

    availableTagNames() {
      return (this.availableTags || []).map(tag => tag.name);
    },

    ratingFormatted() {
      if(this.review && this.review.rating) {
        return Number(this.review.rating).toFixed(1).replace('.0', '');
      }
      return null;
    }
  },

  created() {
    this.isLoggedIn = !!this.user?.email;
  },

  methods: {
    togglePolicy() {
      this.isPolicyShown = !this.isPolicyShown;
    },
  },
};
</script>
<style lang="scss">
@import '~@article/pixel/dist/style/variables';

.product-review-summary-container {
  .product-review-policy-container {
    border-top: 1px solid var(--grey-ultra-light);
    padding-top: var(--space-6);
  }

  .product-review-summary {
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--space-6);

    @media (max-width: $mobile-breakpoint - 1) {
      display: block;
      flex-wrap: wrap;
    }
  }

  .product-review-summary-heading {
    min-width: 250px;
  }

  .product-review-average-text {
    @media (max-width: $mobile-breakpoint - 1) {
      display: none;
    }
  }

  .product-review-summary-details {
    display: flex;
    align-items: center;
    margin-top: var(--space-1);
  }

  .product-review-summary-single-row {
    display: flex;
    align-items: center;

    .product-review-summary-details {
      margin-top: 0;
    }
  }

  .product-review-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    @media (max-width: $mobile-breakpoint - 1) {
      display: block;
      width: 100%;
    }
  }

  .review-tags-container {
    margin-top: var(--space-2);
  }

  .product-review-action {
    @media (max-width: $mobile-breakpoint - 1) {
      width: 100%;
    }
  }

  .product-review-loader {
    @media (max-width: $mobile-breakpoint - 1) {
      display: none;
    }
  }

  .star-filters,
  .product-review-login {
    margin-left: var(--space-4);

    @media (max-width: $mobile-breakpoint - 1) {
      width: 100%;
      margin-top: var(--space-4);
      margin-left: 0;
    }
  }

  .show-review-policy {
    display: flex;
    align-items: center;
    margin-left: var(--space-1);
    font-size: var(--font-size-12);
  }
}
</style>
